import React from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Card, CardHeader, CardBody, Button, Badge as BadgeUI, Nav, NavItem, NavLink } from "reactstrap";
import NotificationAlert from "react-notification-alert";
import classnames from "classnames";
import Swal from "sweetalert2";
import api from "./../../../Api.js";
import SimpleHeader from "./../../../components/Headers/SimpleHeader.jsx";
import GoldDisplay from "./GoldDisplay.jsx";
import { getLpcPreviewStyle } from "./../../../helper/lpcHelper.js";

/**
 * GoldShop — lojinha de items cosméticos (regra 5).
 */
class GoldShop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      balance: 0,
      activeTab: 'all',
      loading: true
    };
  }

  async componentDidMount() {
    await this.loadShop();
    await this.loadBalance();
  }

  async loadShop() {
    try {
      var res = await api.shopList();
      this.setState({ items: res.data || [], loading: false });
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  async loadBalance() {
    if (!this.props.user || !this.props.user.id) return;
    try {
      var res = await api.getRpgStatus(this.props.user.id);
      this.setState({ balance: (res.data.gold && res.data.gold.balance) || 0 });
    } catch (e) {}
  }

  notify(type, title, message) {
    try {
      this.refs.notificationAlert.notificationAlert({
        place: 'tr',
        message: <div className="alert-text"><span className="alert-title">{title}</span><span> {message}</span></div>,
        type: type, icon: 'ni ni-bell-55', autoDismiss: 5
      });
    } catch (e) {}
  }

  async buy(item) {
    if (item.owned) {
      this.notify('warning', 'Já possui', 'Você já tem ' + item.name);
      return;
    }
    if (this.state.balance < item.goldCost) {
      this.notify('warning', 'Saldo insuficiente', 'Você precisa de ' + (item.goldCost - this.state.balance) + ' gold a mais');
      return;
    }
    var confirm = await Swal.fire({
      title: 'Comprar ' + item.name + '?',
      html: 'Custa <strong>' + item.goldCost + ' 🪙</strong> · seu saldo: <strong>' + this.state.balance + ' 🪙</strong>',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#dc3545',
      confirmButtonText: '<i class="fas fa-shopping-cart"></i> Comprar',
      cancelButtonText: '<i class="fas fa-times"></i> Cancelar'
    });
    if (!confirm.isConfirmed) return;

    try {
      var res = await api.shopBuy(item.id);
      if (res.data && res.data.success) {
        this.notify('success', '🎉 ' + res.data.item.name, 'comprado!');
        await this.loadShop();
        await this.loadBalance();
      }
    } catch (e) {
      var msg = (e.response && e.response.data && e.response.data.error) || 'Falha na compra';
      this.notify('warning', 'Erro', msg);
    }
  }

  getBySlot(slot) {
    if (slot === 'all') return this.state.items;
    return this.state.items.filter(function (i) { return i.slot === slot; });
  }

  rarityColor(r) {
    var c = { common: '#9E9E9E', rare: '#2196F3', epic: '#9C27B0', legendary: '#FF9800', mythic: '#F44336' };
    return c[r] || '#9E9E9E';
  }

  render() {
    var slots = [
      { key: 'all', label: 'Todos', icon: 'fas fa-th' },
      { key: 'top', label: 'Cabelo', icon: 'fas fa-hat-wizard' },
      { key: 'helmet', label: 'Capacete', icon: 'fas fa-hard-hat' },
      { key: 'torso', label: 'Armadura', icon: 'fas fa-shield-alt' },
      { key: 'legs', label: 'Calça', icon: 'fas fa-running' },
      { key: 'feet', label: 'Botas', icon: 'fas fa-shoe-prints' },
      { key: 'glasses', label: 'Óculos', icon: 'fas fa-glasses' },
      { key: 'beard', label: 'Barba', icon: 'fas fa-user-tie' },
      { key: 'eyes', label: 'Olhos', icon: 'fas fa-eye' },
      { key: 'weapon', label: 'Arma', icon: 'fas fa-khanda' },
      { key: 'shield', label: 'Escudo', icon: 'fas fa-shield' }
    ];

    return (
      <React.Fragment>
        <div className="rna-wrapper"><NotificationAlert ref="notificationAlert" /></div>
        {!this.props.embedded && <SimpleHeader name="🪙 Lojinha do Aventureiro" way={[{ name: "Loja", url: "/shop" }]} />}

        <Container className={this.props.embedded ? "mt-3" : "mt--6"} fluid>
          {/* Header com saldo */}
          <Card className="shadow mb-3" style={{ background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)', color: '#fff', border: 'none' }}>
            <CardBody className="text-center">
              <h3 className="mb-1" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                <i className="fas fa-store mr-2" />
                Lojinha do Aventureiro
              </h3>
              <div className="mt-2"><GoldDisplay balance={this.state.balance} /></div>
            </CardBody>
          </Card>

          <Card className="shadow">
            <CardHeader className="border-0">
              <Nav tabs style={{ borderBottom: 'none', flexWrap: 'wrap' }}>
                {slots.map((s) => (
                  <NavItem key={s.key}>
                    <NavLink
                      className={classnames({ active: this.state.activeTab === s.key })}
                      onClick={() => this.setState({ activeTab: s.key })}
                      style={{ cursor: 'pointer', fontSize: '0.85rem' }}
                    >
                      <i className={s.icon + ' mr-1'} /> {s.label}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
            </CardHeader>
            <CardBody>
              {this.state.loading ? (
                <div className="text-center py-5"><i className="fas fa-spinner fa-spin fa-2x text-muted" /></div>
              ) : (
                <Row>
                  {this.getBySlot(this.state.activeTab).map((item) => {
                    var color = this.rarityColor(item.rarity);
                    var canAfford = this.state.balance >= item.goldCost;
                    return (
                      <Col xs="6" sm="4" md="3" lg="2" key={item.id} className="mb-3">
                        <div style={{
                          borderRadius: '10px',
                          padding: '10px',
                          background: '#fff',
                          border: '2px solid ' + color + '60',
                          boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                          textAlign: 'center',
                          opacity: item.owned ? 0.6 : 1,
                          minHeight: '210px'
                        }}>
                          {/* Preview */}
                          <div style={{
                            width: '90px', height: '90px', margin: '0 auto',
                            background: 'linear-gradient(180deg, #b3d9ff, #87ceeb)',
                            borderRadius: '8px', overflow: 'hidden',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            border: '2px solid ' + color
                          }}>
                            {item.lpcLayer && <div style={getLpcPreviewStyle(item.lpcLayer, 80, item.slot)} />}
                          </div>
                          <h6 className="mt-2 mb-1" style={{ fontSize: '0.8rem' }}>{item.name}</h6>
                          <BadgeUI pill style={{ background: color, color: '#fff', fontSize: '0.6rem' }}>
                            {item.rarity}
                          </BadgeUI>
                          <div className="mt-2">
                            {item.owned ? (
                              <Button size="sm" color="success" disabled block>
                                <i className="fas fa-check mr-1" /> Adquirido
                              </Button>
                            ) : (
                              <Button
                                size="sm"
                                color={canAfford ? 'warning' : 'secondary'}
                                block
                                onClick={() => this.buy(item)}
                                disabled={!canAfford}
                                style={{ fontSize: '0.75rem' }}
                              >
                                <i className="fas fa-coins mr-1" />
                                {item.goldCost}
                              </Button>
                            )}
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              )}
            </CardBody>
          </Card>

          {/* Link pra skills */}
          <Card className="shadow mt-3" style={{ background: 'linear-gradient(135deg, #6f42c1, #9c27b0)', color: '#fff', border: 'none' }}>
            <CardBody className="text-center py-3">
              <i className="fas fa-magic mr-2" />
              <span>Já é nível 2?</span>
              <a href="/shop/skills" className="btn btn-light btn-sm ml-3">
                <i className="fas fa-bolt mr-1" />
                Escolher Habilidade
              </a>
            </CardBody>
          </Card>
        </Container>
      </React.Fragment>
    );
  }
}

export default connect(state => ({ user: state.user }))(GoldShop);
